<script setup>
import { Handle, Position } from '@vue-flow/core'


</script>

<template>
  <div class="end-node">

    <img src="../../../assets/images/endJourney.svg" />
    <span>{{$t('big_title_end_the_journey')}}</span>

    <Handle id="input" type="target" :position="Position.Top"/>

  </div>
</template>

<style scoped>
.end-node {
  height: 100%;
  width: 100%;
  padding: 5px 10px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  background: #fff;
  color: #101828;
  border-radius: 6px;
  box-shadow: none;
  font-size: 16px;
  font-family: 'euclid_regular', sans-serif;
  border: 1px solid #e74c3c;
}

.end-node img {
  width: 24px;
  height: 24px;
}

</style>
